
















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ToggleButton extends Vue {
  @Prop({ default: '#ffffff' })
  private readonly selectedBackgroundColour!: string;

  @Prop({ default: '#ffffff' })
  private readonly selectedColour!: string;

  @Prop({ default: '#ffffffcc' })
  private readonly backgroundColour!: string;

  @Prop({ default: '#000' })
  private readonly colour!: string;

  @Prop({ required: true })
  private readonly items!: string[];

  @Prop()
  private readonly default!: string;

  private selected: string | null = this.default;

  select(item: string) {
    this.selected = item;

    this.$emit('change', this.selected);
  }
}
